export default __webpack_public_path__ + "static/media/jewelry.7af3643f.png";